<template functional>
    <div class="col-12 d-flex justify-content-between py-4">
        <div>
            <h2 class="mb-0">
                <slot></slot>
            </h2>
        </div>
        <div class="d-flex align-items-center">
            <slot name="actions"></slot>
        </div>
    </div>
</template>

<script>
    export default {
        name: "Heading"
    }
</script>
